import AdminPostManageModal from "@components/_modals/Group/AdminPostManageModal";

import usePostModal from "./hooks/usePostModal";
import PostModalView from "./view";

/**
 * PostModal — the post detail overlay: photo on the left, publisher / text /
 * actions and the comment thread on the right. Declarative: the owner keeps
 * `open` + `postId` (on the community page they come from `?post=<id>`).
 */
export default function PostModal({ postId, open, onClose }) {
    const state = usePostModal({ postId, open, onClose });

    return (
        <>
            <PostModalView {...state} open={open} onClose={onClose} />
            <AdminPostManageModal modalRef={state.adminModalRef} />
        </>
    );
}
